export async function prepareSessionWorktree(session, {sourceRepo, base, bridge, apiFetch}) {
  try {
    const wt = await bridge.worktree.create({
      sessionId: session.id,
      base: base || session.branch || 'main',
      sourceRepo: sourceRepo || undefined,
    });
    if (!wt?.path) return { ok: false, session, error: wt?.error || 'Worktree não foi criado.' };
    if (wt && wt.path) {
      const persist = await apiFetch(`/api/code-ide/sessions/${session.id}/worktree`, {
        method: 'POST',
        body: { path: wt.path, branch: wt.branch },
      });
      if (!persist.ok) return { ok: false, session, error: persist.error || 'Worktree criado, mas o vínculo não foi salvo. Retome a mesma intenção.' };
      if (persist.ok) {
        session = {
          ...session,
          worktree_path: wt.path,
          branch: wt.branch || session.branch,
        };
      }
    }
  } catch (err) {
    // Worktree creation failed — the logical session still exists, so
    // we surface the error but don't roll back. User can retry by
    // deleting + recreating.
    return { ok: false, session, error: err?.message || 'Falha ao criar worktree.' };
  }
  return {ok: true, session};
}
